function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3337 5.00004V14.5834C13.3337 16.425 11.842 17.9167 10.0003 17.9167C8.15866 17.9167 6.66699 16.425 6.66699 14.5834V4.16671C6.66699 3.01671 7.60033 2.08337 8.75033 2.08337C9.90033 2.08337 10.8337 3.01671 10.8337 4.16671V12.9167C10.8337 13.375 10.4587 13.75 10.0003 13.75C9.54199 13.75 9.16699 13.375 9.16699 12.9167V5.00004H7.91699V12.9167C7.91699 14.0667 8.85033 15 10.0003 15C11.1503 15 12.0837 14.0667 12.0837 12.9167V4.16671C12.0837 2.32504 10.592 0.833374 8.75033 0.833374C6.90866 0.833374 5.41699 2.32504 5.41699 4.16671V14.5834C5.41699 17.1167 7.46699 19.1667 10.0003 19.1667C12.5337 19.1667 14.5837 17.1167 14.5837 14.5834V5.00004H13.3337Z",
  fill: "#676773"
});

var SvgIcAttachFileGrey = function SvgIcAttachFileGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcAttachFileGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-attach-file-grey.7f6382fa.svg";
export { ForwardRef as ReactComponent };